import configureAxios from 'configure/axios';

const axios = configureAxios();

export const fetchAll = (subId) => axios.get('bypassed/plans/',  { params: { subscription_id: subId } });
export const find = (id) => axios.get(`bypassed/plans/${id}/`);
export const upcomingCycles = (subscription) => axios.get('bypassed/cycles/upcoming/', { params: { subscription } });
